import BurgerIcon from 'assets/icons/BurgerIcon';
import DropIcon from 'assets/icons/DropIcon';
import { useCallback } from 'react';
import './styles.scss';

export interface ManualXMLFileDescriptionProps {
  id: number
  fileName: string
  handleRemove: (id?: number) => void
  handleReplace: (id: number) => void
}

const ManualXMLFileDescription = (props: ManualXMLFileDescriptionProps) => {
  const { id, fileName, handleRemove, handleReplace } = props;

  const handleReplaceAction = useCallback(() => {
    handleReplace(id)
  }, [handleReplace, id])

  const handleRemoveAction = useCallback(() => {
    handleRemove(id)
  }, [handleRemove, id])

  return(
    <div className="manual-xml-file-description">
      <div className="file-name">
        <BurgerIcon />
        <span>{fileName}</span>
      </div>
      <div className="file-actions">
        <span onClick={handleReplaceAction}>Reemplazar</span>
        <DropIcon onClick={handleRemoveAction}/>
      </div>
    </div>
  )
}

export default ManualXMLFileDescription;